import React from 'react';
import { companyInfo } from '../mock/data';
import { Facebook, Instagram, Linkedin } from 'lucide-react';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  const footerLinks = {
    services: [
      { label: 'Glass Railings', href: '#services' },
      { label: 'Aluminum Railings', href: '#services' },
      { label: 'Custom Installations', href: '#services' }
    ],
    company: [
      { label: 'About Us', href: '#about' },
      { label: 'Our Work', href: '#gallery' },
      { label: 'Contact', href: '#contact' }
    ],
    serviceAreas: [
      'Vancouver',
      'Burnaby',
      'Surrey',
      'Richmond',
      'Coquitlam',
      'New Westminster'
    ]
  };

  return (
    <footer className="bg-slate-900 text-slate-300">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8 py-16">
        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-12 mb-12">
          {/* Company Info */}
          <div>
            <img 
              src="https://customer-assets.emergentagent.com/job_polosi-railings/artifacts/l0a8bsyg_c35df9ca56d27f2c01ab1bb017420a8c790577e9c9899e8e06f1f612eaec8253.png"
              alt="AP Glass Railings Logo"
              className="h-16 w-auto mb-4"
            />
            <p className="text-slate-400 mb-6 leading-relaxed">
              {companyInfo.yearsOfExperience} years of excellence in glass and aluminum railing installations 
              across {companyInfo.location}.
            </p>
            <div className="flex gap-4">
              <a
                href="#"
                className="w-10 h-10 bg-slate-800 rounded-lg flex items-center justify-center hover:bg-blue-600 transition-colors duration-300"
                aria-label="Facebook"
              >
                <Facebook className="h-5 w-5" />
              </a>
              <a
                href="#"
                className="w-10 h-10 bg-slate-800 rounded-lg flex items-center justify-center hover:bg-blue-600 transition-colors duration-300"
                aria-label="Instagram"
              >
                <Instagram className="h-5 w-5" />
              </a>
              <a
                href="#"
                className="w-10 h-10 bg-slate-800 rounded-lg flex items-center justify-center hover:bg-blue-600 transition-colors duration-300"
                aria-label="LinkedIn"
              >
                <Linkedin className="h-5 w-5" />
              </a>
            </div>
          </div>

          {/* Services */}
          <div>
            <h4 className="text-white text-lg font-semibold mb-4">Services</h4>
            <ul className="space-y-3">
              {footerLinks.services.map((link, index) => (
                <li key={index}>
                  <a
                    href={link.href}
                    className="hover:text-blue-400 transition-colors duration-300 inline-block"
                  >
                    {link.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          {/* Company */}
          <div>
            <h4 className="text-white text-lg font-semibold mb-4">Company</h4>
            <ul className="space-y-3">
              {footerLinks.company.map((link, index) => (
                <li key={index}>
                  <a
                    href={link.href}
                    className="hover:text-blue-400 transition-colors duration-300 inline-block"
                  >
                    {link.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          {/* Service Areas */}
          <div>
            <h4 className="text-white text-lg font-semibold mb-4">Service Areas</h4>
            <ul className="space-y-2">
              {footerLinks.serviceAreas.map((area, index) => (
                <li key={index} className="text-slate-400">
                  {area}
                </li>
              ))}
            </ul>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="border-t border-slate-800 pt-8">
          <div className="flex flex-col md:flex-row justify-between items-center gap-4">
            <p className="text-slate-400 text-sm">
              © {currentYear} {companyInfo.name}. All rights reserved.
            </p>
            <div className="flex flex-col sm:flex-row gap-4 text-sm">
              <a href={`tel:${companyInfo.phone}`} className="hover:text-blue-400 transition-colors duration-300">
                {companyInfo.phone}
              </a>
              <span className="hidden sm:inline text-slate-600">|</span>
              <a href={`mailto:${companyInfo.email}`} className="hover:text-blue-400 transition-colors duration-300">
                {companyInfo.email}
              </a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
